import React from "react";
import Button from "./Button";
import { SVG } from "../../assets/images/svg";
import { withAuthorization, Analytics } from "../../utilities";
import classnames from "classnames";
import { withStore } from "../../store";

const PlayButton: React.FunctionComponent<any> = ({ small, className, contentItem, enableAbroadBanner, onAnalyticsSelect, store: { isAbroad } }) => {
  const AuthorizedButton = withAuthorization(Button);
  const handlePlay = () => {
    // When rendered inside a module (e.g. a hero), the caller reports the module-scoped
    // viewability.select itself (group_name = module name). Otherwise fall back to the default
    // page-scoped select for standalone play buttons (brand/episode detail pages).
    if (onAnalyticsSelect) {
      onAnalyticsSelect();
    } else {
      Analytics.userActionSelectPlayableContent(contentItem);
    }

    if(isAbroad){
      enableAbroadBanner();
      window.scrollTo(0, 0);//For scroll to the top
    }
  }
  return <AuthorizedButton text="Play" className={classnames("play", { small }, [className])} outlined={false} svgIcon={SVG.Play} contentItem={contentItem}  onClick={handlePlay}/>
};

export default withStore(PlayButton);
